module.exports = "@media only screen and (max-width: 768px) {\r\n\r\n\tmat-expansion-panel{\r\n\t\t-webkit-box-shadow: none;\r\n\t\t        box-shadow: none;\r\n\t}\r\n\t\r\n\t.expansion-header{\r\n\t\theight: 1200px;\r\n\t}\r\n\t.theRecruitment{\r\n\t\tmargin-top: 10px;\r\n\t}\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/recruitment/mobile.style.css
// module id = ./src/app/components/recruitment/mobile.style.css
// module chunks = main